/**
 * 轮播图API服务
 * 处理轮播图相关的API请求
 */
import { API_URL } from './config';

/**
 * 获取轮播图列表
 * @returns {Promise<Array>} 轮播图数据数组
 */
export const getBanners = async () => {
  try {
    const response = await fetch(API_URL.BANNER);
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // 检查接口返回状态
    if (data && data.code === 1) {
      return data.data;
    } else {
      console.error('获取轮播图失败:', data.msg);
      return [];
    }
  } catch (error) {
    console.error('获取轮播图请求出错:', error);
    return [];
  }
};

export default {
  getBanners
}; 